__turbopack_context__.v({
  "cartDrawer": "GhzdgW_cartDrawer",
  "cartDrawerNoRibbon": "GhzdgW_cartDrawerNoRibbon",
  "cartDrawerWithRibbon": "GhzdgW_cartDrawerWithRibbon",
});
